/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const DeleteIcon = ({ width = 12, height = 12, color = '#f7f9fa', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 12 12' fill={color} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 0.5C4 0.223858 4.22386 0 4.5 0H7.5C7.77614 0 8 0.223858 8 0.5C8 0.776142 7.77614 1 7.5 1H4.5C4.22386 1 4 0.776142 4 0.5ZM0 2.5C0 2.22386 0.223858 2 0.5 2H11.5C11.7761 2 12 2.22386 12 2.5C12 2.77614 11.7761 3 11.5 3H10.473L10.078 10.1109C10.0191 11.1708 9.14253 12 8.08106 12H3.91902C2.85756 12 1.98099 11.1708 1.9221 10.111L1.52701 3H0.5C0.223858 3 0 2.77614 0 2.5ZM2.52855 3L2.92056 10.0555C2.95 10.5854 3.38829 11 3.91902 11H8.08106C8.6118 11 9.05009 10.5854 9.07952 10.0555L9.47145 3H2.52855Z'
    />
  </svg>
);

export default DeleteIcon;
